import React from 'react'

const React_Coding_Practice_42 = () => {
  return (
    <div>
      <h1>Coding Pratice 42</h1>
    </div>
  )
}

export default React_Coding_Practice_42
